export const categories = [
  {
    slug: 'ent',
    name: '娱乐八卦',
    desc: '明星动态、演出幕后与圈内新料',
    icon: 'ri-fire-line',
    count: 42,
  },
  {
    slug: 'society',
    name: '社会民生',
    desc: '街头巷尾的新鲜事与身边热点',
    icon: 'ri-community-line',
    count: 37,
  },
  {
    slug: 'tech',
    name: '互联网科技',
    desc: '平台动向、产品上新与行业风向',
    icon: 'ri-cpu-line',
    count: 28,
  },
  {
    slug: 'campus',
    name: '校园生活',
    desc: '高校热点、考试季与青春话题',
    icon: 'ri-book-open-line',
    count: 24,
  },
  {
    slug: 'career',
    name: '职场视角',
    desc: '打工人关心的薪酬与行业变化',
    icon: 'ri-briefcase-line',
    count: 21,
  },
  {
    slug: 'sports',
    name: '体育赛场',
    desc: '赛事进程、胜负悬念与运动话题',
    icon: 'ri-basketball-line',
    count: 19,
  },
  {
    slug: 'finance',
    name: '财经观察',
    desc: '市场波动、利率变化与消费趋势',
    icon: 'ri-line-chart-line',
    count: 23,
  },
  {
    slug: 'city',
    name: '城市现场',
    desc: '各地突发天气与城市现场记录',
    icon: 'ri-building-line',
    count: 16,
  },
];